import { Button, Image, Modal, Pagination, Radio } from "antd";

import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ControlOutlined } from "@ant-design/icons";
import defaultPic from "../../../assets/images/icons/test-profile-pic.png";
import ErrorIcon from "../../../assets/images/icons/Pagenotfound.svg";
import { getRequest } from "../../../api/http";
import DownloadStudent from "./downloadStudent";
import Search from "antd/lib/input/Search";
import placementOfficer from "../../../api/placementOfficer";
import { LoadingView } from "../../common";

function StudentsUnderJobs() {
  const location = useLocation();
  const { jobDetails, status } = location.state || {};
  const navigate = useNavigate();
  const [searchValue, setSearchValue] = useState("");
  const [modalVisible, setModalVisible] = useState(false);
  const [studentData, setStudentData] = useState([]);
  const [loading, setloading] = useState(false);

  console.log("Job details:", jobDetails);
  console.log("Status:", status);
  const eventId = jobDetails.eventId;
  const handleOk = (value) => {
    setModalVisible(false);
  };
  const onSearch = async (value) => {
    console.log(value);
    setSearchValue(value);
    fetchData();
  };
  const showModal = () => {
    setModalVisible(true);
  };
  const handleCancel = () => {
    setModalVisible(false);
  };

  useEffect(() => {
    fetchData();
  }, [eventId, status, jobDetails.id, searchValue]);

  const fetchData = async () => {
    try {
      setloading(true);
      const response = await getRequest(
        placementOfficer.getReportOfStudent(
          eventId,
          searchValue,
          status,
          jobDetails.id
        )
      );
      setStudentData(response?.content);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setloading(false);
    }
  };
  if (loading) return <LoadingView message="Loading..." />;
  return (
    <div className="studentList">
      <div
        className="headingButton headingTitle"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignContent: "center",
        }}
      >
        <h3
          style={{ fontWeight: "bolder", fontSize: "25px", color: "#2C4394" }}
        >
          {status.charAt(0).toUpperCase() + status.slice(1).toLowerCase()}{" "}
          Students
        </h3>

        <Button
          onClick={() => navigate(-1)}
          type="primary"
          style={{ height: 40 }}
        >
          Back
        </Button>
      </div>
      <div className="searchRow studentTableSearch">
        <Search
          allowClear
          placeholder="Find students"
          onSearch={onSearch}
          enterButton
        />
      </div>
      {(status === "OFFERED" ||
        status === "OFFER_ACCEPTED" ||
        status === "OFFER_REJECTED") && (
        <div
          style={{
            marginBottom: 25,
            display: "flex",
            flexDirection: "row-reverse",
          }}
        >
          <DownloadStudent data={studentData} status={status} />
        </div>
      )}
      {studentData.length > 0 ? (
        studentData.map((student) => (
          <div className="card-long">
            <div style={{ display: "flex", alignItems: "center" }}>
              <div
                style={{
                  display: "flex",
                  marginLeft: 10,
                  cursor: "pointer",
                  paddingRight: 300,
                }}
                onClick={() =>
                  navigate(`/phistory/${student?.studentId}`, {
                    state: { eventId: eventId },
                  })
                }
              >
                <div className="card">
                  {/* Assuming there is no profile image for students */}
                  <img
                    src={student?.profileUrl || defaultPic}
                    alt="Profile"
                    width={40}
                    height={40}
                  />
                </div>
                <div className="jobsHead">
                  <div className="jobsHeadCol">
                    <h3>{student?.studentName}</h3>
                    <ul>
                      <li>
                        <span className="JobInfo">
                          <span className="infoNameType">Phone</span>
                          <span className="infoNameValue">
                            {student?.studentPhone}
                          </span>
                        </span>
                      </li>
                      <li>
                        <span className="JobInfo">
                          <span className="infoNameType">Email</span>
                          <span className="infoNameValue">
                            {student.studentEmail}
                          </span>
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))
      ) : (
        <div className="errorMsg">
          <Image src={ErrorIcon} preview={false} />
          <h4>No {status} students</h4>
        </div>
      )}

      {/* <div className="paginationRow">
        <Pagination pageSize={20} total={studentData.length} />
      </div> */}

      <Modal
        title="Filters"
        visible={modalVisible}
        onOk={() => handleOk()}
        onCancel={handleCancel}
        footer={[
          <Button key="back" onClick={handleCancel}>
            Cancel
          </Button>,
          <Button key="submit" type="primary" onClick={() => handleOk()}>
            Ok
          </Button>,
        ]}
      >
        <Radio.Group>
          <Radio value="all">All</Radio>
          <Radio value="approve">Approved</Radio>
          <Radio value="reject">Rejected</Radio>
          <Radio value="request">Pending</Radio>
        </Radio.Group>
      </Modal>
    </div>
  );
}

export default StudentsUnderJobs;
